import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

const CHUNK_RELOAD_KEY = 'aunak-webapp-chunk-reload';

function isStaleChunkError(message: string): boolean {
  return (
    message.includes('Loading chunk') ||
    message.includes('ChunkLoadError') ||
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed')
  );
}

function reloadOnceOnStaleChunk(): void {
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    return;
  }
  sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
  window.location.reload();
}

window.addEventListener('error', (event) => {
  const message = String(event.message || (event.error && event.error.message) || '');
  if (isStaleChunkError(message)) {
    reloadOnceOnStaleChunk();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const message = String((reason && reason.message) || reason || '');
  if (isStaleChunkError(message)) {
    reloadOnceOnStaleChunk();
  }
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    window.setTimeout(() => sessionStorage.removeItem(CHUNK_RELOAD_KEY), 10000);
  })
  .catch((err) => console.error(err));
